<template>
  <div
    v-if="$store.getters.marchand && $store.getters.marchand._env === 'live'"
    class="row"
    style="padding: 5px"
  >
    <div class="col-12 mb-4">
      <div class="pb-4"></div>
      <div class="mt-3 mb-0 pb-0">
        <v-alert type="info">
          {{ $t("school_entry") }}
        </v-alert>
      </div>
      <v-card elevation="0" class="mt-4">
        <v-row>
          <!-- Loop through the schools and display each as a card -->
          <v-col
            v-for="(school, index) in schools"
            :key="index"
            cols="12"
            sm="6"
            md="3"
          >
            <v-card
              style="background-color: white !important; cursor: pointer"
              class="p-2"
            >
              <!-- Top row with image, name, and menu -->
              <v-row align="center" no-gutters>
                <v-col cols="auto">
                  <v-img
                    :src="image_base_link + school._logo"
                    :lazy-src="image_base_link + school._logo"
                    width="50"
                    height="50"
                    class="align-center"
                    rounded
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-col>
                <v-col>
                  <h3 class="text-lg">
                    {{ school._name ? school._name : "N/A" }}
                  </h3>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="auto" class="pr-3">
                  <v-btn
                    x-small
                    dark
                    color="orange"
                    fab
                    outlined
                    class="mx-2"
                    @click="editItemAction(school, 3)"
                  >
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn
                    x-small
                    dark
                    outlined
                    color="pink"
                    fab
                    @click="editItemAction(school, 4)"
                  >
                    <v-icon small>mdi-trash-can-outline</v-icon>
                  </v-btn>
                  <!-- <v-menu rounded="b-xl">
                    <template v-slot:activator="{ attrs, on }">
                      <v-icon class="black--text" v-bind="attrs" v-on="on"
                        >mdi-dots-vertical</v-icon
                      >
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(action_item, index) in actions_items"
                        :key="index"
                        link
                        @click="editItemAction(school, index)"
                      >
                        <v-list-item-icon>
                          <v-icon color="#29B3A6">{{
                            action_item.avatar
                          }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title
                            v-text="action_item.title"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu> -->
                </v-col>
              </v-row>

              <!-- Subtitle and Text -->
              <v-card-subtitle>
                <v-icon small>mdi-email-outline</v-icon>
                {{
                  school._contactMail ? school._contactMail : "N/A"
                }}</v-card-subtitle
              >
              <v-card-text>
                <p>
                  <v-icon small>mdi-map-marker-outline</v-icon
                  >{{ school._address }}
                </p>
                <!--  <p>
                  <small>
                    <v-icon small>mdi-calendar-outline</v-icon>
                    Ajouter le :
                    {{
                      new Date(school._createdAt).toLocaleDateString()
                    }}</small
                  >
                </p> -->
                <div class="text-right">
                  <v-btn
                    small
                    outlined
                    color="black"
                    class="mx-2"
                    @click="editItemAction(school, 0)"
                  >
                    paramètres <v-icon small>mdi-tune-vertical</v-icon>
                  </v-btn>
                  <v-btn
                    small
                    outlined
                    color="#29B3A6"
                    @click="editItemAction(school, 2)"
                  >
                    Gerer <v-icon small>mdi-arrow-right-thin</v-icon>
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="3" style="min-height: 213px">
            <div @click="dialogCustomer = true" class="add_btn">
              <div class="text-center" style="font-size: 15pt">
                Ajouter une école
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <v-dialog v-model="dialogCustomer" max-width="700px">
        <v-card>
          <v-card-text>
            <v-form ref="clientForm" v-model="clientFormIsValid">
              <v-container v-show="classestep === 1">
                <v-row>
                  <v-col lg="12">
                    <h3 class="pb-5">Ajouter une nouvelle école</h3>
                    <h4 style="font-weight: bold">Informations de l'école</h4>
                  </v-col>

                  <v-col lg="6" sm="12">
                    <label for="">Nom </label>
                    <v-text-field
                      solo
                      v-model="schoolToSave._name"
                      :rules="requiredRules"
                      label="Nom"
                    ></v-text-field>
                  </v-col>
                  <v-col lg="6" sm="12">
                    <label for="">Email</label>
                    <v-text-field
                      solo
                      v-model="schoolToSave._contactMail"
                      label="Adresse Email"
                      :rules="requiredRules"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-col v-if="!editingCustomer" cols="12" sm="12">
                  <label
                    >Image de l'école <br />
                    <small v-if="id"
                      >Ne cliquez que si vous souhaitez mettre à jour le logo du
                      service</small
                    ></label
                  >
                  <v-file-input
                    v-model="file"
                    accept="image/png, image/jpeg"
                    ref="files"
                    :rules="fileRules"
                    solo
                    placeholder="Téléversez l' image de l'école"
                    label="Téléversez l'image de l'école"
                    prepend-icon="mdi-paperclip"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip small label color="primary">
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                </v-col>

                <!-- <v-row>
                    <v-col cols="12" lg="6">
                      <label>Numéro de téléphone </label>
                      <vue-phone-number-input
                          :preferred-countries="['BJ']"
                          :only-countries="['BJ']"
                          default-country-code="BJ"
                          show-code-on-list
                          clearable
                          v-model="tel"
                          :translations="{
                            countrySelectorLabel: 'Code pays',
                            countrySelectorError: 'Choisir un pays',
                            phoneNumberLabel: 'Numéro de téléphone',
                            example: 'Exemple :'
                          }"
                          @update="getphoneresult"
                      />
                    </v-col>
                  </v-row> -->

                <v-row>
                  <v-col lg="12" sm="12">
                    <label for="">Adresse de localisation </label>
                    <v-textarea
                      solo
                      v-model="schoolToSave._address"
                      label="Adresse de localisation"
                      rows="1"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="dark"
              @click="(dialogCustomer = false), (editingCustomer = false)"
            >
              Annuler
            </v-btn>

            <v-btn
              v-if="!editingCustomer"
              :loading="loadings.school_saving"
              color="primary"
              :disabled="
                schoolToSave._name === null ||
                schoolToSave._contactMail === '' ||
                schoolToSave._address === ''
              "
              @click="saveSchool()"
            >
              Enregistrer
            </v-btn>
            <v-btn
              v-if="editingCustomer"
              :loading="loadings.school_saving"
              :disabled="
                schoolToSave._name === null ||
                schoolToSave._contactMail === '' ||
                schoolToSave._address === ''
              "
              color="primary"
              @click="updateSchool()"
            >
              Mettre à jour
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
  <div v-else>
    <go-to-params></go-to-params>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from "vuex";
import GoToParams from "../administrators/globalComponents/GoToParams";
import { fontAwesomePicker } from "font-awesome-picker";
import { client } from "../../store/services/client";
import Swal from "sweetalert2";
import { env } from "../../../env";

export default {
  components: {
    GoToParams,
    "font-awesome-picker": fontAwesomePicker,
  },
  label: "School",
  data() {
    return {
      page: 0,
      total_pages: 0,
      classestep: 1,
      image_base_link: env.image_base_url,
      file: undefined,
      requiredRules: [(v) => !!v || "Ce champ est recquis"],
      fileRules: [(v) => !!v || this.$t("file_required")],
      loadings: {
        schools: false,
        categories: false,
        categoriySaving: false,
        school_saving: false,
      },
      clientFormIsValid: false,
      schools: undefined,
      all_classes: undefined,
      dialogDeleteCategory: false,
      dialogDelete: false,
      country_key: "",
      lazy: false,
      errors: {},
      editingCustomer: false,
      dialogCustomer: false,
      id: undefined,
      schoolToSave: {
        _name: "",
        _contactMail: "",
        _address: "",
      },
      editedIndex: -1,
      editedItem: {},
      actions_items: [
        { title: "Gérer", avatar: "mdi-eye" },
        // {title: "Configuration", avatar: 'mdi-cog-transfer'},
        { title: "Modifier", avatar: "mdi-pencil" },
        { title: "Supprimer", avatar: "mdi-delete" },
      ],

      categories_actions_items: [
        { title: "Modifier", avatar: "mdi-pencil" },
        { title: "Supprimer", avatar: "mdi-delete" },
      ],
    };
  },

  mounted() {
    this.initialize();
  },
  methods: {
    editItemAction(item, index) {
      switch (index) {
        case 0:
          this.$router.push({
            name: "intramScholar.manage",
            params: { school_id: item._id },
          });
          break;
        case 1:
          this.$router.push({
            name: "intramScholar.transactions",
            params: { school_id: item._id },
          });
          break;
        case 2:
          this.$router.push({
            name: "intramScholar.academic.years",
            params: { school_id: item._id },
          });
          break;
        case 3:
          this.editingCustomer = true;
          this.schoolToSave = item;
          this.dialogCustomer = true;
          break;
        case 4:
          this.toggleDeleteSchool(item);
          break;
      }
    },

    async initialize() {
      this.getAllSchools();
    },
    async getAllSchools() {
      this.loadings.schools = true;
      const response = await client({
        method: "get",
        url: "/school-payments/schools/owner/me",
      })
        .then((resp) => resp.data)
        .catch((error) => {
          this.loadings.schools = false;
          return {
            error: "true",
          };
        });
      if (!response.error) {
        this.loadings.schools = false;
        console.log(response);

        this.schools = response;

        console.log(this.schools);
      }
    },
    async saveSchool() {
      if (this.$refs.clientForm.validate()) {
        let data = new FormData();

        // this.files.forEach((image) => {
        // });
        data.append("_logo", this.file);

        // console.log(this.files)
        data.append("_name", this.schoolToSave._name);
        data.append("_contactMail", this.schoolToSave._contactMail);
        data.append("_address", this.schoolToSave._address);
        this.loadings.school_saving = true;
        const response = await client({
          method: "post",
          url: "/school-payments/schools",
          data,
        })
          .then((resp) => {
            this.$refs.clientForm.reset();
            console.log(resp.data);
            return resp.data;
          })
          .catch((error) => {
            return {
              error: "true",
            };
          });
        this.loadings.school_saving = false;
        this.dialogCustomer = false;
        this.getAllSchools();
        this.toast(response.type, response.message);
      }
    },

    async updateSchool() {
      if (this.$refs.clientForm.validate()) {
        this.loadings.school_saving = true;
        const response = await client({
          method: "PUT",
          url: `/school-payments/schools/${this.id}`,
          data: this.schoolToSave,
        })
          .then((resp) => {
            this.$refs.clientForm.reset();
            return resp.data;
          })
          .catch((error) => {
            return {
              error: "true",
            };
          });
        this.loadings.school_saving = false;
        this.editingCustomer = false;
        this.dialogCustomer = false;
        this.getAllSchools();
        this.toast(response.type, response.message);
      }
    },
    toggleEditSchool(item) {
      this.dialogCustomer = true;
      this.editingCustomer = true;
      this.schoolToSave = item;

      this.id = item._id;
      console.log(this.id);
    },
    editCategoryItemAction(item, index) {
      switch (index) {
        case 0:
          this.toggleEdtiCategory(item);
          break;
        case 1:
          this.toggleDeleteCategory(item);
          break;
      }
    },
    toggleDeleteSchool(item) {
      Swal.fire({
        icon: "warning",
        timerProgressBar: false,
        text: this.$t("delete_warning"),
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
        showCancelButton: true,
        cancelButtonColor: "#CCC",
        confirmButtonColor: "#29B3A6",
        preConfirm: async () => {
          Swal.showLoading();
          try {
            const response = await client({
              method: "delete",
              url: `/school-payments/schools/${item._id}`,
            });
            Swal.hideLoading();
            Swal.fire({
              icon: "success",
              text: "Suppression réussi",
              confirmButtonText: "Ok",
              cancelButtonText: "Annuler",
              cancelButtonColor: "#CCC",
              confirmButtonColor: "#29B3A6",
            });
            console.log(response);
            await this.getAllSchools();
            return response.data;
          } catch (error) {
            Swal.hideLoading();
            Swal.fire({
              icon: "error",
              text: "Erreur lors de la suppression",
              confirmButtonText: "Ok",
              cancelButtonText: "Annuler",
              cancelButtonColor: "#CCC",
              confirmButtonColor: "#29B3A6",
            });
            return { error: "true" };
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        console.log(result);
        if (result.isConfirmed) {
          console.log("finish with modal");
          this.getAllSchools();
        }
      });
      console.log("finish with modal 2");
    },
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
  created() {
    this.checkisDashboard();
    this.initialize();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
};
</script>

<style scoped>
.circular--square {
  border-radius: 50%;
}

.circular--square {
  border-radius: 50% 50%;
  width: 50px;
  height: 50px;
  object-fit: contain;
}
svg:not(:host).svg-inline--fa,
svg:not(:root).svg-inline--fa {
  font-size: 20px;
}
.add_btn {
  cursor: pointer;
  border: 2px dashed gray;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
}
.add_btn:hover {
  background-color: rgb(188, 188, 188);
  color: white;
  transition-duration: 700ms;
}
</style>
